/**
 * 将稿件中页字数为非法时 如undefined或者null等转化为0
 * @author zhang.yingyu
 */
angular.module('trsToZeroModule', [])
    .filter("trsToZero", [function() {
        return function(str) {
            if(str==='null'||str==='undefined'||!str){
                str=0;
            }
            return str;
        };
    }]);